// This chooses a screen, never a user or a balance. The API verifies order ownership.
export const rubTopupReturnPath = (search, startParam, hash = "") => {
  const params = new URLSearchParams(search || "");
  const hashParams = new URLSearchParams(hash.replace(/^#/, ""));
  const orderId = params.get("order_id");
  if (/^rub:\d{1,20}:[a-f0-9]{32}$/.test(orderId || "")) {
    return `/rub-topup?order_id=${encodeURIComponent(orderId)}`;
  }
  const token = String(startParam || params.get("tgWebAppStartParam") || hashParams.get("tgWebAppStartParam") || "");
  const match = /^rubtopup_(\d{1,20})_([a-f0-9]{32})$/.exec(token);
  return match ? `/rub-topup?order_id=${encodeURIComponent(`rub:${match[1]}:${match[2]}`)}` : null;
};
